import { worker } from './browser';
worker.start();
